import { getRayon, getGorod } from "../../../utilities";

export const issuingCertificatesHeader = {
  // gridKey: "grid-container-republican",
  inputsOptions: {
    licenseTypeName: {
      key: "licenseTypeName",
      label: "Удостоверение типа",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: false,
      needInForm: true,
      lang: "ru",
    },
    theoreticalExam: {
      key: "theoreticalExam",
      label: "Дата и номер протокола по проверке знаний, теория",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: false,
      needInForm: true,
      lang: "ru",
    },
    practicalExam: {
      key: "practicalExam",
      label: "Дата и номер протокола по проверке знаний, практика",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: false,
      needInForm: true,
      lang: "ru",
    },
    validTypeName: {
      key: "validTypeName",
      label: "Вид прогулочного судна",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: false,
      needInForm: true,
      lang: "ru",
    },
    validZoneName: {
      key: "validZoneName",
      label: "Зона плавания",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: false,
      needInForm: true,
      lang: "ru",
    },
  },
};

export const interestedPersonRepublican = {
  caption: "Сведения о заинтересованном лице",
  gridKey: "grid-container-republican",
  blockVisibility: true,
  inputsOptions: {
    personalDataCaption: {
      key: "personalDataCaption",
      caption: "Личные данные",
      needInForm: true,
    },
    addressCaption: {
      key: "addressCaption",
      caption: "Адрес",
      needInForm: true,
    },
    surname: {
      key: "surname",
      label: "Фамилия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    name: {
      key: "name",
      label: "Имя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    midname: {
      key: "midname",
      label: "Отчество",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: false,
      needInForm: true,
      lang: "ru",
    },
    docType: {
      key: "docType",
      label: "Документ",
      type: "selectWithSearch",
      placeholder: "Выберите документ",
      fieldModeView: true,
      disabled: false,
      isSearchable: false,
      required: true,
      needInForm: true,
      options: [],
    },
    docSeries: {
      key: "docSeries",
      label: "Серия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    docNum: {
      key: "docNum",
      label: "Номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 7,
      pattern: {
        value: /^[0-9]+[0-9]*$/,
        message: `Введите только цифры`,
      },
    },
    docDateIssue: {
      key: "docDateIssue",
      label: "Дата выдачи",
      type: "date",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    docDepartment: {
      key: "docDepartment",
      label: "Кем выдан",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    persNum: {
      key: "persNum",
      label: "Идентификационный номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 14,
      pattern: {
        value: /^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/,
        message: `Введите номер в формате "0000000A000AA0"`,
      },
    },
    address: {
      key: "address",
      label: "Адрес",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      textarea: "textarea",
      required: true,
      needInForm: true,
      disabled: false,
    },
    birthDate: {
      key: "birthDate",
      label: "Дата рождения",
      type: "date",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      customButton: false,
    },
    phone: {
      key: "phone",
      label: "Телефон",
      type: "text",
      placeholder: "+375 (29) ___-__-__",
      fieldModeView: true,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9+\s,;()-]*$/,
        message: `Введены недопустимые символы`,
      },
    },
    birthPlace: {
      key: "birthPlace",
      label: "Место рождения",
      type: "text",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      placeholder: "Введите полное наименование страны",
      lang: "ru",
    },
  },
};
export const interestedPersonInternational = {
  caption: "Сведения о заинтересованном лице",
  gridKey: "grid-container-international",
  blockVisibility: true,
  inputsOptions: {
    personalDataCaption: {
      key: "personalDataCaption",
      caption: "Личные данные",
      needInForm: true,
    },
    addressCaption: {
      key: "addressCaption",
      caption: "Адрес",
      needInForm: true,
    },
    surname: {
      key: "surname",
      label: "Фамилия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    surnameEn: {
      key: "surnameEn",
      label: "Surname",
      type: "text",
      placeholder: "Введите на латинице",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      upperCase: true,
      lang: "en",
      pattern: {
        value: /^[A-Za-z]+[A-Za-z]*$/,
        message: `Заполнение на английском языке`,
      },
    },
    name: {
      key: "name",
      label: "Имя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    nameEn: {
      key: "nameEn",
      label: "Name",
      type: "text",
      placeholder: "Введите на латинице",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      upperCase: true,
      lang: "en",
      pattern: {
        value: /^[A-Za-z]+[A-Za-z]*$/,
        message: `Заполнение на английском языке`,
      },
    },
    midname: {
      key: "midname",
      label: "Отчество",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: false,
      needInForm: true,
      lang: "ru",
    },
    docType: {
      key: "docType",
      label: "Документ",
      type: "selectWithSearch",
      placeholder: "Выберите документ",
      fieldModeView: true,
      disabled: false,
      isSearchable: false,
      required: true,
      needInForm: true,
      options: [],
    },
    docSeries: {
      key: "docSeries",
      label: "Серия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    docNum: {
      key: "docNum",
      label: "Номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 7,
      pattern: {
        value: /^[0-9]+[0-9]*$/,
        message: `Введите только цифры`,
      },
    },
    docDateIssue: {
      key: "docDateIssue",
      label: "Дата выдачи",
      type: "date",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    docDepartment: {
      key: "docDepartment",
      label: "Кем выдан",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "ru",
    },
    persNum: {
      key: "persNum",
      label: "Идентификационный номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: true,
      required: true,
      needInForm: true,
      maxlength: 14,
      customButton: true,
      buttonName: "Найти",
      customIcon: true,
      upperCase: true,
    },
    address: {
      key: "address",
      label: "Адрес",
      type: "text",
      placeholder: "Введите",
      fieldModeView: true,
      textarea: "textarea",
      required: true,
      needInForm: true,
      disabled: false,
    },
    birthDate: {
      key: "birthDate",
      label: "Дата рождения",
      type: "date",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      customButton: false,
    },
    phone: {
      key: "phone",
      label: "Телефон",
      type: "text",
      placeholder: "+375 (29) ___-__-__",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      pattern: {
        value: /^[0-9+\s,;()-]*$/,
        message: `Введены недопустимые символы`,
      },
    },
    addressEn: {
      key: "addressEn",
      label: "Address",
      type: "text",
      placeholder:
        "Введите на латинице номер дома/квартиры, улицу, населенный пункт, район, область, страну сокращенно",
      fieldModeView: false,
      textarea: "textarea",
      rows: 3,
      disabled: false,
      required: true,
      needInForm: true,
      lang: "en",
      pattern: {
        value: /^[A-Za-z]+[A-Za-z]*$/,
        message: `Заполнение на английском языке`,
      },
    },
    birthPlace: {
      key: "birthPlace",
      label: "Место рождения",
      type: "text",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
      placeholder: "Введите полное наименование страны",
      lang: "ru",
    },
    birthPlaceEn: {
      key: "birthPlaceEn",
      label: "Place of birth",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    residence: {
      key: "residence",
      label: "Гражданство",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    residenceEn: {
      key: "residenceEn",
      label: "Residence",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
  },
};
export const representPerson = {
  caption: "Сведения о представителе заинтересованного лица",
  gridKey: "grid-container-represent",
  blockVisibility: true,
  inputsOptions: {
    personalDataCaption: {
      key: "personalDataCaption",
      caption: "Личные данные",
      needInForm: false,
    },
    addressCaption: {
      key: "addressCaption",
      caption: "Адрес",
      needInForm: false,
    },
    agentSurname: {
      key: "agentSurname",
      label: "Фамилия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    agentName: {
      key: "agentName",
      label: "Имя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    agentMidname: {
      key: "agentMidname",
      label: "Отчество",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    agentDocType: {
      key: "agentDocType",
      label: "Документ",
      type: "selectWithSearch",
      placeholder: "Выберите документ",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [],
    },
    agentDocSeries: {
      key: "agentDocSeries",
      label: "Серия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    agentDocNum: {
      key: "agentDocNum",
      label: "Номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      maxLength: 7,
    },
    agentDocDate: {
      key: "agentDocDate",
      label: "Дата выдачи",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    agentDocDepartment: {
      key: "agentDocDepartment",
      label: "Кем выдан",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    agentPersNum: {
      key: "agentPersNum",
      label: "Идентификационный номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      maxlength: 14,
      pattern: {
        value: /^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/,
        message: `Введите номер в формате "0000000A000AA0"`,
      },
    },
    agentCountry: {
      key: "agentCountry",
      label: "Страна",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: true,
      required: false,
      needInForm: true,
      defaultValue: "Республика Беларусь",
    },
    agentOblastId: {
      key: "agentOblastId",
      label: "Область или г.Минск",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: false,
      needInForm: true,
      options: [],
    },
    agentRayonId: {
      key: "agentRayonId",
      label: "Район",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: true,
      required: false,
      needInForm: true,
      options: [],
    },
    agentGorodId: {
      key: "agentGorodId",
      label: "Населённый пункт",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: true,
      required: false,
      needInForm: true,
      options: [],
    },
    agentUlica: {
      key: "agentUlica",
      label: "Улица",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[а-яА-ЯёЁ0-9\s.,;:!?-]*$/,
        message: `Заполнение на русском языке, можно использовать цифры и пробелы`,
      },
    },
    agentDom: {
      key: "agentDom",
      label: "Дом",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    agentKorpus: {
      key: "agentKorpus",
      label: "Корпус",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    agentKv: {
      key: "agentKv",
      label: "Квартира",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    agentPhone: {
      key: "agentPhone",
      label: "Телефон",
      type: "text",
      placeholder: "+375 (29) ___-__-__",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9+\s,;()-]*$/,
        message: `Введены недопустимые символы`,
      },
    },
    agentDoverennost: {
      key: "agentDoverennost",
      label: "Сведения о доверенности",
      type: "text",
      textarea: true,
      rows: 3,
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
  },
};

export const datesDocOfTraining = {
  caption:
    "Сведения об обучении правилам управления моторными маломерными судами, мощность двигателя которых превышает 3,7 киловатта (5 лошадиных сил)",
  gridKey: "grid-container-dates-doc-of-training",
  blockVisibility: true,
  inputsOptions: {
    selfTraining: {
      key: "selfTraining",
      label: "Самоподготовка",
      type: "checkbox",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      pointerEvent: false,
    },
    datesCaption: {
      key: "datesCaption",
      caption: "Срок обучения",
      needInForm: true,
    },
    trainingBegin: {
      key: "trainingBegin",
      label: "С",
      type: "date",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    trainingEnd: {
      key: "trainingEnd",
      label: "По",
      type: "date",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    docCaption: {
      key: "docCaption",
      caption: "Документ, подтверждающий прохождение обучения",
      needInForm: true,
    },
    trainingDocType: {
      key: "trainingDocType",
      label: "Вид",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: true,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [],
    },
    trainingDocNum: {
      key: "trainingDocNum",
      label: "Серия , номер",
      type: "text",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    trainingDocDate: {
      key: "trainingDocDate",
      label: "Дата выдачи",
      type: "date",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    trainingDocDepartment: {
      key: "trainingDocDepartment",
      label: "Кем выдан",
      type: "text",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
  },
};
export const infoAboutExistingCertificate = {
  caption:
    "Сведения о наличии  удостоверения на право управления моторным маломерным судном, мощность двигателя которого превышает 3,7 киловатта (5 лошадиных сил) или международного удостоверения на право управления прогулочным судном (при его наличии)",
  gridKey: "grid-container-existing-certificate",
  blockVisibility: true,
  inputsOptions: {
    licenseNumExist: {
      key: "licenseNumExist",
      label: "Номер",
      type: "text",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
    licenseDateExist: {
      key: "licenseDateExist",
      label: "Дата выдачи",
      type: "date",
      fieldModeView: true,
      disabled: false,
      required: true,
      needInForm: true,
    },
  },
};

export const infoMedicalConditions = {
  blockVisibility: true,
  inputsOptions: {
    medConditionsId: {
      key: "medConditionsId",
      label: "Медицинские показания",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [{ value: null, label: "—", key: "medConditionsId" }],
    },
  },
};

export const isNeedToPaySelector = {
  key: "isNeedToPaySelector",
  label: "Выставить счет на оплату",
  type: "selectWithSearch",
  placeholder: "Выберите",
  fieldModeView: false,
  disabled: false,
  isSearchable: false,
  required: true,
  needInForm: true,
  options: [
    {
      value: true,
      label: "Да",
      key: "isNeedToPaySelector",
    },
    {
      value: false,
      label: "Нет",
      key: "isNeedToPaySelector",
    },
  ],
};

export function setDocOptionsInterestedFromDictionaries(docLib) {
  if (docLib.length > 0) {
    const validLib = docLib.map((item) => {
      return {
        ...item,
        key: "docType",
      };
    });
    if (interestedPersonRepublican.inputsOptions.docType.options.length === 0) {
      interestedPersonRepublican.inputsOptions.docType.options.push(...validLib);
    }
    if (interestedPersonInternational.inputsOptions.docType.options.length === 0) {
      interestedPersonInternational.inputsOptions.docType.options.push(...validLib);
    }
    if (representPerson.inputsOptions.agentDocType.options.length === 0) {
      representPerson.inputsOptions.agentDocType.options.push(...validLib);
    }
  }
}
export function setOblOptionsFromDictionaries(oblLib) {
  const validLib = oblLib.map((item) => {
    return {
      ...item,
      key: "agentOblastId",
    };
  });
  if (representPerson.inputsOptions.agentOblastId.options.length === 0) {
    representPerson.inputsOptions.agentOblastId.options.push(...validLib);
  }
}

export function setTrainingDocTypesOptionsFromDictionaries(lib) {
  if (lib.length > 0) {
    const validLib = lib.map((item) => {
      return {
        ...item,
        key: "trainingDocType",
      };
    });
    if (datesDocOfTraining.inputsOptions.trainingDocType.options.length === 0) {
      datesDocOfTraining.inputsOptions.trainingDocType.options.push(...validLib);
    }
  }
}
export function setDatesDocOfTrainingFields(selfTraining) {
  if (selfTraining) {
    for (let item in datesDocOfTraining.inputsOptions) {
      if (item !== "selfTraining") {
        datesDocOfTraining.inputsOptions[item].needInForm = false;
        datesDocOfTraining.gridKey = "grid-container-dates-doc-of-training-selftraining";
      }
    }
  } else {
    for (let item in datesDocOfTraining.inputsOptions) {
      if (item !== "selfTraining") {
        datesDocOfTraining.inputsOptions[item].needInForm = true;
        datesDocOfTraining.gridKey = "grid-container-dates-doc-of-training";
      }
    }
  }
  return datesDocOfTraining;
}

export const setHeaderFieldsByCertificateType = (typeId) => {
  if (Number(typeId) === 1) {
    issuingCertificatesHeader.inputsOptions.validTypeName.needInForm = false;
    issuingCertificatesHeader.inputsOptions.validZoneName.needInForm = false;
  } else {
    issuingCertificatesHeader.inputsOptions.validTypeName.needInForm = true;
    issuingCertificatesHeader.inputsOptions.validZoneName.needInForm = true;
  }
  return issuingCertificatesHeader;
};

export function setMedicalConditionOptions(lib) {
  if (lib.length > 0) {
    const validLib = lib.map((item) => {
      return {
        ...item,
        key: "medConditionsId",
      };
    });
    if (infoMedicalConditions.inputsOptions.medConditionsId.options.length === 1) {
      infoMedicalConditions.inputsOptions.medConditionsId.options.push(...validLib);
    }
  }
}

export function setOptionsFromDictionaries(lib, option) {
  const updateLib = lib.map((item) => ({
    ...item,
    key: option,
    label: option.indexOf("En") !== -1 ? item.countryFullnameEn : item.countryFullname,
  }));
  Object.values(interestedPersonInternational).map((item) => {
    if (item[option]?.options.length === 0) {
      item[option].options.push(...updateLib);
    }
  });
}

export async function setOptionsRepresentPerson(id, key) {
  if (Number(id) === 5) {
    representPerson.inputsOptions.agentRayonId.options = [];
    representPerson.inputsOptions.agentRayonId.disabled = true;
    representPerson.inputsOptions.agentGorodId.options = [];
    representPerson.inputsOptions.agentGorodId.disabled = true;
    return representPerson;
  } else {
    switch (key) {
      case "agentOblastId": {
        const rayons = await getRayon(id);
        const rayonsValid =
          rayons?.map((item) => {
            item.key = "agentRayonId";
            return item;
          }) || [];
        representPerson.inputsOptions.agentRayonId.options = rayonsValid;
        representPerson.inputsOptions.agentRayonId.disabled = representPerson.inputsOptions.agentRayonId
          .options.length
          ? false
          : true;
        representPerson.inputsOptions.agentGorodId.options = [];
        representPerson.inputsOptions.agentGorodId.disabled = true;
        return representPerson;
      }
      case "agentRayonId": {
        const gorod = await getGorod(id);
        const gorodValid =
          gorod?.map((item) => {
            item.key = "agentGorodId";
            return item;
          }) || [];
        representPerson.inputsOptions.agentGorodId.options = gorodValid;
        representPerson.inputsOptions.agentGorodId.disabled = representPerson.inputsOptions.agentGorodId
          .options.length
          ? false
          : true;
        return representPerson;
      }
      default:
        return representPerson;
    }
  }
}

export function setGridsByMode(mode, type) {
  if (mode === "add") {
    representPerson.gridKey = "grid-container-represent";
    representPerson.inputsOptions.addressCaption.needInForm = false;
    representPerson.inputsOptions.personalDataCaption.needInForm = false;
  } else {
    representPerson.gridKey = "grid-container-represent-view";
    representPerson.inputsOptions.addressCaption.needInForm = true;
    representPerson.inputsOptions.personalDataCaption.needInForm = true;
  }
  return {
    header: issuingCertificatesHeader,
    interested: type === 1 ? interestedPersonRepublican : interestedPersonInternational,
    represent: representPerson,
    training: datesDocOfTraining,
    existingCertificate: infoAboutExistingCertificate,
    medCondition: infoMedicalConditions,
  };
}
